export const choices = [
    {
        value: "Afghan",
        label: "Afghan ",
    },
    {
        value: "Albanian",
        label: "Albanian ",
    },
    {
        value: "Algerian",
        label: "Algerian ",
    },

]